$(document).ready(function(){

  ///////////////////////////////
  //////////// CURSOR DPE GES /////////////

  var energy = $('#dpe').text();
  var ges = $('#ges').text();

  var cursorEnergy = 0;
  var cursorGes = 0;

  switch (true) {
    case energy>450:
      cursorEnergy = 0;
      break;
    case energy>=331 && energy<=450:
      cursorEnergy = 25;
      break;
    case energy>= 231 && energy<=330:
      cursorEnergy = 50;
      break;
    case energy>=151 && energy<=230:
      cursorEnergy = 75;
      break;
    case energy>=91 && energy<=150:
      cursorEnergy = 100;
      break;
    case energy>=51 && energy<=90:
      cursorEnergy = 125;
      break;
    case energy<=50:
      cursorEnergy = 150;
    break;
    default:
  }

  switch (true) {
    case ges>80:
      cursorGes = 0;
      break;
    case ges>=56 && ges<=80:
      cursorGes = 25;
      break;
    case ges>= 36 && ges<=55:
      cursorGes = 50;
      break;
    case ges>=21 && ges<=35:
      cursorGes = 75;
      break;
    case ges>=11 && ges<=20:
      cursorGes = 100;
      break;
    case ges>=6 && ges<=10:
      cursorGes = 125;
      break;
    case ges<=5:
      cursorGes = 150;
    break;
    default:
  }

  $(".cursorEnergy").css({bottom : cursorEnergy+"px"})
  $(".cursorGes").css({bottom : cursorGes+"px"})

  ///////////////////////////////
  //////////// SLIDE /////////////

  var indexSlide = 1;
  var totalImg = 0
  var mobileSize = false

  $('.preview img').each(function(){
    $(this).resizeToParent();
    totalImg++;
  })

  if(totalImg === 1){
    $('.sliderNav').css({display:"none"});
  }

  $('.slideNext').click(function(){
    if(indexSlide < 4){
      indexSlide++;
      $('.preview .show').next().addClass('show');
    }else{
      $('.preview .show').each(function(n){
        if(n>1){
          $('.preview .show').next().removeClass('show')
        }
      })
      indexSlide = 1;
    }
  })

  $('.slidePrev').click(function(){
    var img = $('.preview .show');
    if(img.length>1){
      indexSlide --;;
      img[img.length-1].classList.remove('show');
    }else{
      $('.preview img').each(function(n){
        $(this).addClass('show');
        indexSlide = 3;
      })
    }

  })

  ///////////////////////////////

  var xMousePos = 0;
  var yMousePos = 0;
  var lastScrolledLeft = 0;
  var lastScrolledTop = 0;
  var onPreview = false;

  $('.content #alur').css('width',$(window).width()/2 - 140);

  if($(window).width() < 920){
    mobileSize = true
    $('.preview').css('height',$('.preview img').height())
    $('.sliderNav').css('height',$('.preview img').height())
  }else if($(window).width() >= 920){
    mobileSize = false
    $('.preview').css('height','auto');
    $('.sliderNav').css('height','auto');
  }

  $(window).resize(function(){
    $('.content #alur').css('width',$(window).width()/2 - 140);
    if($(window).width() < 920 && mobileSize === false){
      mobileSize = true
      $('.preview').css('height',$('.preview img').height())
      $('.sliderNav').css('height',$('.preview img').height())

      $('.container-offre').removeClass("open")
      $('.container-offre').css("width","100%")
      $('.pointer').removeClass("open")

    }else if($(window).width() >= 920 && mobileSize){
      mobileSize = false
      $('.preview').css('height','auto');
      $('.sliderNav').css('height','auto');
    }

  })


  $(".pointer").click(function(){
    $(this).toggleClass('open')
    if(!$(this).hasClass('open')){
      $('.preview').css('width','50%')
      // $('.sliderNav').css('width','50%')

      $('.container-offre').css('width','100%')

    }else{
      $('.preview').css('width',$('.preview img').width())

      var imgWidth = $('.preview img').width()
      $('.container-offre').css('width',imgWidth*2+'px')

    }
    $('.container-offre').toggleClass('open')
  })









  $("#print").click(function(){
    window.print()
  })

  $('.actions #recall, .actions #share').click(function(){

    $('.info').css({display : "none"})
    $('.info').text("")

    $('.actions .button').each(function(){
      $(this).parent().removeClass('open');
      $(this).find('#label').css({display:"inline"});
    })
    $(this).parent().toggleClass('open');
    $(this).find('#label').css({display:"none"});
    $(this).next().next().focus();
  })

  $(document).keypress(function(e) {
    if(e.which == 13) {

      if($("#recallInput").is(":focus")){
        recall();
      }
      if($("#shareInput").is(":focus")){
        share();
      }

    }
  });

  /////////// RECALL ////////////////

  var dataRecall = {
   from : '',
   phone : '',
   page : window.location.href
  }

  var stepRecall = 1;

  $('#validatePhone').click(function(){
    recall();
  })

  function recall(){

    var value = $('#recallInput').val();

    if(value !== '' && stepRecall == 1){
      $('#recallInput').val('');
      $('#recallInput').attr('placeholder','Votre numéro de téléphone');
      $('#buttonRecall #step').text('2/2');
      dataRecall.from = value
      stepRecall = 2;
    }else if(stepRecall == 2){

      var phoneReplaces = value.replace(/ |,|-|_/g, '');
      var regexPhone = /^\d{10}$/;

      if(regexPhone.test(phoneReplaces)){

        dataRecall.phone = value
        $('#recallInput').val('');
        $('#recallInput').attr('placeholder','Votre nom et prénom');
        $('#buttonRecall #step').text('1/2');
        $('#buttonRecall').removeClass('open');
        $('#buttonRecall #label').css({display:"inline"});

        stepRecall = 1;

        $.ajax({
          type: "POST",
          url: 'https://api.agenceduchateau.bakasable.fr/recall',
          data: dataRecall,
          success: function(res){
            if(res.message = 'recall'){
              $('.info').text('Nous allons vous appeler dès que possible au : '+dataRecall.phone)
              $('.info').css({display : "block"})
              setTimeout(function(){
                $('.info').text('')
                $('.info').css({display : "none"})
              },4000)
            }
            dataRecall = {
              from : '',
              phone : '',
              page :''
            }
          },
          error: function() { alert('Erreur envoie email'); }
        });

      }else{
        $('.info').text("Le numéro indiqué n'est pas valide.")
        $('.info').css({display : "block"})
        setTimeout(function(){
          $('.info').text("")
          $('.info').css({display : "none"})
        },4000)

      }

    }

  }

  /////////// SHARE ////////////////

  var dataShare = {
    from : '',
    to : ''
  }
  var stepShare = 1;

  $('#validateShare').click(function(){
    share();
  })

  function share(){
    var value = $('#shareInput').val();
    var regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if(value !== '' && stepShare == 1){
      $('#shareInput').val('');
      $('#shareInput').attr('placeholder','Email de votre ami');
      $('#buttonShare #step').text('2/2');
      // console.log("L'agence du chateau sera avertie que vous avez partagé ce bien.");
      $('.info').css({display : "block"})
      $('.info').text("L'agence du chateau sera avertie que vous avez partagé ce bien.")
      dataShare.from = value
      stepShare = 2;
    }else if(stepShare == 2){
      if(regexEmail.test(value)){
        dataShare.to = value
        $('#shareInput').val('');
        $('#shareInput').attr('placeholder','Votre nom et prénom');
        $('#buttonShare #step').text('1/2');
        $('#buttonShare').removeClass('open');
        $('#buttonShare #label').css({display:"inline"});

        stepShare = 1;


        dataShare.page = window.location.href

        $.ajax({
          type: "POST",
          url: 'https://api.agenceduchateau.bakasable.fr/share',
          data: dataShare,
          success: function(res){
            if(res.message = 'share'){
              $('.info').text('Un email a été envoyé à : '+dataShare.to)
              $('.info').css({display : "block"})
              setTimeout(function(){
                $('.info').text('')
                $('.info').css({display : "none"})
              },4000)
            }
            dataShare = {
              from : '',
              to : ''
            }
          },
          error: function() { alert('Erreur envoie email'); }
        });



      }else{
        $('.info').text("L'email indiqué n'est pas valide.")
        $('.info').css({display : "block"})
        setTimeout(function(){
          $('.info').text("")
          $('.info').css({display : "none"})
        },4000)

      }

    }
  }

});



// WEBPACK FOOTER //
// ./src/js/offre.js